import React from "react";
import PropTypes from "prop-types";
import OrderDeliveryDetails from "./OrderDeliveryDetails";
import ProductDetailsBlock from "./ProductDetailsBlock";
import OrderStorePickUp from "./OrderStorePickUp";
import { Checkout } from "npmlinks-constants";

const OrderConsignmentsBlock = props => {
  const { productDetails } = props;
  return (
    <div>
      {productDetails.map((product, index) => (
        <div className="nw-orderconsignmentblock" key={index}>
          {product.shippingMethod ===
          Checkout.CHECKOUT_DELIVERY_OPTIONS.STOREPICK ? (
            <OrderStorePickUp.component {...product} />
          ) : (
            <OrderDeliveryDetails.component {...product} />
          )}
          <ProductDetailsBlock.component {...product} />
        </div>
      ))}
    </div>
  );
};

OrderConsignmentsBlock.propTypes = {
  productDetails: PropTypes.arrayOf(
    PropTypes.shape({
      products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      shippingMethod: PropTypes.string.isRequired,
      deliveryAddressDetails: PropTypes.object,
      storeDetails: PropTypes.object,
    }),
  ),
};

export { default as OrderDeliveryDetails } from "./OrderDeliveryDetails";
export { default as OrderStorePickUp } from "./OrderStorePickUp";
export { default as ProductDetailsBlock } from "./ProductDetailsBlock";

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderConsignmentsBlock,
  component: OrderConsignmentsBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderConsignmentsBlock/index.js